import API from "../../services";
import { USER_API } from "../../services";
import { BsData } from "../../models/BsData";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  ADD_EXCH_BET,
  BET_ODDS_CHANGE,
  REMOVE_EXCH_BET,
  SET_EXCH_BET_STAKE,
  CLEAR_EXCHANGE_BETS,
  FETCH_OPEN_BETS_SUCCESS,
  CLEAR_SUCCESS_BETS,
  SET_BETTING_INPROGRESS,
  PLACE_BET_SUCCESS,
  UPDATE_BET_DETAILS,
  BETSLIP_ODDS_CHANGED_MSG,
  UPDATE_BET_SLIP,
  ACCEPT_ODDS_CHANGE,
} from "./betSlipActionTypes";
import { setLoading } from "../index";
import store from "../store";

export const addExchangeBet = (data: BsData) => {
  return async (dispatch: Function) => {
    dispatch(clearExchcngeBets());
    dispatch(addBetHandler(data));
  };
};

const addBetHandler = (data: BsData) => {
  return {
    type: ADD_EXCH_BET,
    payload: data,
  };
};

export const updateBetListHandler = (data: BsData[]) => {
  return {
    type: UPDATE_BET_DETAILS,
    payload: data,
  };
};

export const removeExchangeBet = (index: number) => {
  return {
    type: REMOVE_EXCH_BET,
    payload: { index },
  };
};

export const setExchangeBetStake = (
  index: number,
  amount: number,
  type: "ADD" | "SET"
) => {
  return {
    type: SET_EXCH_BET_STAKE,
    payload: {
      index,
      amount,
      type,
    },
  };
};

export const clearExchcngeBets = () => {
  return {
    type: CLEAR_EXCHANGE_BETS,
    payload: [],
  };
};
export const exchangeBetOddsChange = (index: number, odds: number) => {
  return {
    type: BET_ODDS_CHANGE,
    payload: { index, odds },
  };
};

const placeBetsSuccess = (result) => {
  return {
    type: PLACE_BET_SUCCESS,
    payload: result,
  };
};
export const placeBet = (data: BsData) => {
  return async (dispatch: Function) => {
    let balance = store.getState().sportsBook.balance;
    if (data?.stakeAmount <= 0 || data?.stakeAmount === undefined) {
      toast.error("Please enter valid stack amount.");
    } else if (balance < data?.stakeAmount) {
      toast.error(
        `Balance is ${balance} not sufficient for this ${data?.stakeAmount} stack.`
      );
    } else {
      let betData = {
        token: sessionStorage.getItem("user_api_token"),
        operatorId: sessionStorage.getItem("psOperatorId"),
        providerId: sessionStorage.getItem("psProviderId"),
        origin: sessionStorage.getItem("lobbyType"),
        ...data,
      };
      try {
        dispatch(setBettingInprogress(true));
        let result = null;
        result = await USER_API.post(`/sportsbet`, betData);
        if (result && result?.data.status === "RS_OK") {
          dispatch(placeBetsSuccess(result.data));
          toast.success("Bet Placed.");
          dispatch(setBettingInprogress(false));
          dispatch(fetchOpenBets(data.eventId, data.sportId));
          dispatch(clearExchcngeBets());
        } else {
          toast.error(result.data.errorDescription);
          dispatch(setBettingInprogress(false));
        }
      } catch (err) {
        console.log(err);
        toast.error(err);
        dispatch(setBettingInprogress(false));
      }
    }
  };
};

const fetchOpenBetsSuccess = (result: BsData[]) => {
    return {
        type: FETCH_OPEN_BETS_SUCCESS,
        payload: result,
    };
};

export const fetchOpenBets = (
    eventId: string,
    sportId: string
) => {
    return async (dispatch: Function) => {

        const data = {
            token: sessionStorage.getItem("user_api_token"),
            operatorId: sessionStorage.getItem("psOperatorId"),
            providerId: sessionStorage.getItem("psProviderId"),
            sportId,
            eventId,
        };

        try {

            console.log("[get-event-bets] Request:", data);

            const result = await USER_API.post(
                "/get-event-bets",
                data
            );

            console.log(
                "[get-event-bets] Response:",
                result.data
            );

            if (result?.data?.status === "RS_OK") {

                const bets = Array.isArray(result.data.bets)
                    ? result.data.bets
                    : [];

                console.log(
                    "[get-event-bets] Loaded bets:",
                    bets
                );

                dispatch(
                    fetchOpenBetsSuccess(bets)
                );

            } else {

                console.warn(
                    "[get-event-bets] Backend returned error:",
                    result.data
                );

                dispatch(
                    fetchOpenBetsSuccess([])
                );
            }

        } catch (err: any) {

            console.error(
                "[get-event-bets] Request failed:",
                err?.response?.data || err
            );

            dispatch(
                fetchOpenBetsSuccess([])
            );
        }
    };
};

export const clearSuccessBets = (successIndices: number[]) => {
  return {
    type: CLEAR_SUCCESS_BETS,
    payload: successIndices,
  };
};

export const setBettingInprogress = (val: boolean) => {
  return {
    type: SET_BETTING_INPROGRESS,
    payload: val,
  };
};

export const setBetSlipOddsChangeMsg = (val: boolean) => {
  return {
    type: BETSLIP_ODDS_CHANGED_MSG,
    payload: val,
  };
};

export const updateBetslipfromWS = (payload) => {
  return {
    type: UPDATE_BET_SLIP,
    payload: payload,
  };
};

export const acceptOddsChange = () => {
  return {
    type: ACCEPT_ODDS_CHANGE,
    payload: true,
  };
};
